import index from './index.js';
import report from './report.js';
import { Router } from '@/legacy/Router';

Router.get('dashboard-legacy', index);
Router.get('report/:any', index);
Router.get('report/:any', report);
